import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSearchLabelList, saveLabel } from "../../actions/user";
import TableCard, { CardData as TableCardData, headerItem } from '../../components/cards/TableCard';
import SearchLabel from "../../components/search-forms/searchLabel";
import { LabelModal } from "../../components/modals/label";
import { Pagination } from "../../components/pagination";
import { StoreState } from "../../types/models/store";
import { Actions, friendlyDate } from "../../utils";
import { COOKIE_PARAMS } from "../../constants";
import useAuth from "../../hooks/useAuth";

const LabelsPage = () => {
    const dispatch = useDispatch();
    const { added_status } = useSelector((state: StoreState) => state.toolbar);
    const { user } = useAuth() as any;

    const [labelListData, setLabelListData] = useState<any>([]);
    const [labelModel, setLabelModel] = useState<any>({});
    const [showModal, setShowModal] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);
    const [timer, setTimer] = useState<any>();

    const [formData, setFormData] = useState<any>({
        pagination: {
            page: 0,
            pages: 0,
            size: 15,
            total: 0
        },
        filter: {
            client: [2],
            keyword: "",
        },
    });

    const [resData, setResData] = useState<any>({
        pagination: {
            page: 0,
            pages: 0,
            size: 10,
            total: 0
        },
        title: "",
        list: [],
        filtered: {
            client: [],
        }
    });

    useEffect(() => {
        let filter = {
            client: user.client?.id ? [user.client.id] : [2],
            keyword: formData.filter.keyword,
        };
        setFormData({ ...formData, filter: filter });
    }, [user.client])

    useEffect(() => {
        clearTimeout(timer);
        setTimer(setTimeout(
            () => {
                loadLabelsAction()
            }, 500
        ));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData]);

    useEffect(() => {
        if (added_status === 'label') {
            loadLabelsAction();
            dispatch({
                type: "SET_ADDED_STATUS",
                payload: ""
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [added_status]);

    const loadLabelsAction = () => {
        setLoading(true);
        setResData({
            ...resData,
            pagination: {
                ...resData.pagination,
                pages: 0,
            },
            title: '',
        });
        getSearchLabelList(formData).then((res: any) => {
            setLoading(false);
            setResData({
                ...res.result,
                title: `found ${res.result.pagination.total.toLocaleString().toString().replace(/,/g, ', ')} results`,
            });
            const result: TableCardData[] = [];
            for (let i = 0; i < res.result.list.length; i++) {
                result.push({
                    id: res.result.list[i].id,
                    data: [
                        {
                            cell: res.result.pagination.page * res.result.pagination.size + i + 1
                        },
                        {
                            cell: res.result.filtered.client.filter((c: any) => c.id === res.result.list[i].client_id).length ?
                                res.result.filtered.client.filter((c: any) => c.id === res.result.list[i].client_id)[0].title : '',
                        },
                        {
                            title: `<a href='/all-releases' onclick="\
                            window.localStorage.setItem('${COOKIE_PARAMS.SELECTED.LABEL}', '${res.result.list[i].short_title}');\
                            ">${res.result.list[i].long_title}</a>`,
                            // comment: res.result.list[i].comments,
                        },
                        {
                            cell: res.result.list[i].short_title,
                        },
                        {
                            cell: res.result.list[i].album_count,
                        },
                        {
                            cell: friendlyDate(res.result.list[i].register_date),
                        },
                        {
                            cell: friendlyDate(res.result.list[i].update_date),
                        },
                    ]
                })
            }
            setLabelListData(result);
        });
    };

    const handleLabelEditAction = (id: number) => {
        let label = resData.list?.filter((l: any) => l.id === id);
        setLabelModel({
            id: id,
            validate: true,
            title: label.length ? label[0]?.long_title : '',
            alias: label.length ? label[0]?.short_title : '',
            comments: label.length ? label[0]?.comments !== null ? label[0]?.comments : '' : '',
            action: Actions.edit,
            message: "",
        });
        setShowModal(true);
    };

    const handleLabelDeleteAction = (id: number) => {
        let label = resData.list?.filter((l: any) => l.id === id);
        setLabelModel({
            id: id,
            validate: true,
            title: label.length ? label[0]?.long_title : '',
            alias: label.length ? label[0]?.short_title : '',
            comments: label.length ? label[0]?.comments : '',
            action: Actions.delete,
            message: "",
        });
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    }

    const handleLabelSaveAction = async (event: { currentTarget: any; preventDefault: () => void; stopPropagation: () => void; }) => {
        const form = event.currentTarget;
        event.preventDefault();
        if (form.checkValidity() === false) {
            event.stopPropagation();
            setLabelModel({ ...labelModel, validate: false, message: '' });
        } else {
            setLabelModel({ ...labelModel, validate: true, message: '' });
            saveLabel({
                ...labelModel,
                action: labelModel.action === Actions.add ? "add" : labelModel.action === Actions.edit ? "edit" : "delete",
                client_id: 2,
            }).then((res: any) => {
                if (res.result.status) {
                    setLabelModel({
                        ...labelModel,
                        title: res.result.status === 2 ? '' : labelModel.title,
                        alias: res.result.status === 1 ? '' : labelModel.alias,
                        message: res.result.message,
                        validate: true,
                    });
                } else {
                    setShowModal(false);
                    loadLabelsAction();
                }
            })
        }
    };

    const handleClient = (client: number) => {
        let list = [];
        formData.filter.client.forEach((g: number) => {
            if (client !== g) list.push(g);
        });
        if (!formData.filter.client.filter((g: number) => g === client).length) {
            list.push(client);
        }
        setFormData({
            pagination: {
                ...formData.pagination,
                page: 0,
            },
            filter: {
                ...formData.filter,
                client: list
            }
        });
    };

    const handleKeyword = (e: any) => {
        setFormData({
            pagination: {
                ...formData.pagination,
                page: 0,
            },
            filter: {
                ...formData.filter,
                keyword: e.target.value
            }
        });
    }

    const handlePage = (page: number) => {
        setFormData({
            ...formData,
            pagination: {
                ...formData.pagination,
                page: page,
            }
        });
    };

    return (
        <div className="page page-label mb-5">
            <SearchLabel
                data={{
                    client: formData.filter.client,
                    clientList: resData.filtered.client,
                    handleClient: handleClient,
                }}
            />
            <div className="">
                <div className="uk-container-large">
                    <div className="search-component search-form">
                        <div className="container uk-container-large">
                            <div className="bg-white border border-white rounded d-flex justify-content-between align-items-center">
                                <input
                                    placeholder="Search labels"
                                    className="border border-white form-control search-track-input"
                                    onChange={handleKeyword}
                                    value={formData.filter.keyword}
                                />
                                <img
                                    src="/imgs/search.svg"
                                    className="me-2 py-2 focus"
                                    alt=""
                                />
                            </div>
                        </div>
                    </div>
                    <TableCard
                        title={resData.title}
                        loading={loading}
                        icon={false}
                        danger={true}
                        filterable={false}
                        className={`label-table w-100`}
                        actions={[Actions.edit, Actions.delete]}
                        data={labelListData}
                        headers={[
                            headerItem("#", '43px'),
                            headerItem("Name", '100px'),
                            headerItem("Title"),
                            headerItem("Alias", '100px'),
                            headerItem("Albums", '100px'),
                            headerItem("Created At", '109px'),
                            headerItem("Updated At", '110px'),
                        ]}
                        onClickEdit={handleLabelEditAction}
                        onClickDelete={handleLabelDeleteAction}
                    />
                    <Pagination
                        className={"mt-4"}
                        pagination={resData.pagination}
                        handlePage={handlePage}
                    />
                    <LabelModal
                        mkey={"label-edit"}
                        show={showModal}
                        model={labelModel}
                        setModel={setLabelModel}
                        closeModal={handleCloseModal}
                        saveModal={handleLabelSaveAction}
                    />
                </div>
            </div>
        </div>
    )

}

export default LabelsPage;